import { Component, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService, AlertService } from 'ng-jhipster';
import * as moment from 'moment';

import { ActivatedRoute } from '@angular/router';

import { Account, LoginModalService, Principal, CARD_UNLIMITED_BOOKINGS_NUMBER, BackOfficeService } from '../shared';

import { NewsArticle } from '../entities/news-article/news-article.model';
import { NewsArticleService } from '../entities/news-article/news-article.service';
import { SchoolCalendar, SchoolCalendarService} from '../entities/school-calendar';
import { School, SchoolService} from '../entities/school';
import { Student, StudentService, StudentUtilService } from '../entities/student';
import { Event, EventService } from '../entities/event';

import { Card, CardService } from '../entities/card';
import { StudentComment, StudentCommentService } from '../entities/student-comment';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import {DEFAULT_FACEBOOK_URL, DEFAULT_INSTAGRAM_URL, DEFAULT_TIKTOK_URL,
    DEFAULT_YOUTUBE_URL, DEFAULT_WEBSITE_URL, DEFAULT_MAILTO, DEFAULT_TELEPHONE} from '../shared/constants/layout.constants';
import { CardType, CardTypeService } from '../entities/card-type';
import { FreeTrialCardInput, OnlineCatalogService } from '../entities/catalog';

@Component({
    selector: 'jhi-home',
    templateUrl: './home.component.html',
    styleUrls: [
        'home.scss'
    ]

})
export class HomeComponent implements OnInit, OnDestroy, AfterViewInit   {
    account: Account;
    student: Student;
    currentSchoolCalendar: SchoolCalendar = new SchoolCalendar();
    modalRef: NgbModalRef;
    currencyCode: string = 'EUR'; // Euro ISO 4217 code
    activeCards: Card [] = [];
    currentSchool: School;
    news: NewsArticle[] = [];
    comments: StudentComment[] = [];
    websiteUrl: string = DEFAULT_WEBSITE_URL;
    facebookUrl: string = DEFAULT_FACEBOOK_URL;
    instagramUrl: string = DEFAULT_INSTAGRAM_URL;
    mailTo: string = 'mailto:' + DEFAULT_MAILTO;
    youtubeUrl: string  = DEFAULT_YOUTUBE_URL;
    tiktokUrl: string = DEFAULT_TIKTOK_URL;
    telephone: string = null;

    highlightedevents: Event[] = [];
    maxHighlightedItems: any;

    hasAdminRights: boolean = false;
    hasTeacherRole: boolean = false;

    // variables to show info cards
    studentCurrentCardInfoLoaded: boolean = false;
    schoolOnlinePaymentsCardInfoLoaded: boolean = false;

    // variables to show the booking window
    bookingWindow: number;

    // variables for the free trial
    freeTrialAvailalbeCardTypes: CardType [] = [];
    showRedeemFreeTrialButton: boolean = false;
    showFreeTrielRedeemSucccessButton: boolean = false;
    isProcessingFreeTrialRequest: boolean = false;

    //variables for new this month
    freeTrials: Card[] = [];
    freeTrialsCardLoading: boolean = false;
    newStudents: Student[] = [];
    newStudentsCardLoading: boolean = false;
    schoolProposeFreeTrials: boolean = false;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private principal: Principal,
        private loginModalService: LoginModalService,
        private eventManager: EventManager,
        private alertService: AlertService,
        private schoolCalendarService: SchoolCalendarService,
        private schoolService: SchoolService,
        private studentService: StudentService,
        private studentCommentService: StudentCommentService,
        private studentUtilService: StudentUtilService,
        private cardService: CardService,
        private cardTypeService: CardTypeService,
        private eventService: EventService,
        private newsArticleService: NewsArticleService,
        private route: ActivatedRoute,
        private backOfficeService: BackOfficeService,
        private onlineCatalogSerice: OnlineCatalogService,
        private router: Router
    ) {
        this.jhiLanguageService.setLocations(['home', 'student',
                                                'card', 'cardType',
                                                'newsArticle', 'student-comment',
                                                'onlineCatalog',
                                                'event']);
    }

    ngOnInit() {
        this.maxHighlightedItems = 3;
        this.hasAdminRights = false;
        this.hasTeacherRole = false;
        this.studentCurrentCardInfoLoaded = false;
        this.schoolOnlinePaymentsCardInfoLoaded = false;
        this.schoolProposeFreeTrials = false;

        this.principal.identity().then((account) => {
            this.account = account;
        });

        this.registerAuthenticationSuccess();
        this.loadAll();
       
    }

    loadAll() {
        this.loadCurrentSchool();
        this.loadSchoolCalendar();
        this.loadRoles();
        this.loadCurrentStudent();
        this.loadThisMonthFreeTrials();
        this.loadThisMonthNewStudents();
    }

    loadSchoolCalendar() {
        this.principal
            .hasAnyAuthority(['ROLE_SCHOOL_ADMIN' ])
            .then(response => {
                if (response) {

                    this.hasAdminRights = true;

                    // we load the calendars to show the message to the admin
                    this.schoolCalendarService
                    .current()
                    .subscribe(
                        (res: HttpResponse<SchoolCalendar[]>) => {
                            let calendars = res.body;
                            if (calendars.length > 0 ) {
                                this.currentSchoolCalendar = calendars[0];
                            } else {
                                this.currentSchoolCalendar = null;
                            }
                        },
                        (res: HttpErrorResponse) => this.onError(res));
                }
            });
    }

    loadRoles() {
        this.principal
        .hasAnyAuthority(['ROLE_TEACHER', 'ROLE_ADVANCED_TEACHER' ])
        .then(response => {
            if (response) {
                this.hasTeacherRole = true;
            }
        });
    }

    ngAfterViewInit() {
       // Nothing to do
    }

    public startAccountOnboardingSession() {
        if (!this.currentSchool) {
            return;
        }

        this.backOfficeService
            .createOrResumeCreateBackofficeAccount(this.currentSchool)
            .subscribe( (chechoutUrl: string) => {
                // we open the onboarding page in same browser so the user can pay
                window.location.href = chechoutUrl;
            } , (error: HttpErrorResponse) => console.log('Error onboarding the account: Unexpected error from the server'));
    }

    onlinePaymentEnabled () {
        return this.currentSchool &&
                this.currentSchool.acceptOnlinePayments &&
                this.currentSchool.onlinePaymentsModuleEnabled &&
                this.currentSchool.backofficeAccountId;
    }

    private loadCurrentSchool() {
         this.schoolService
            .findCurrent()
            .subscribe(school => {
            this.currentSchool = school;
            this.schoolOnlinePaymentsCardInfoLoaded = true;

            if (this.currentSchool) {
                this.facebookUrl = this.currentSchool.facebookUrl;
                this.instagramUrl = this.currentSchool.instagramUrl;
                this.youtubeUrl = this.currentSchool.youtubeUrl;
                this.tiktokUrl = this.currentSchool.tiktokUrl;
                this.websiteUrl = this.currentSchool.websiteUrl;
                this.telephone  = 'tel:' + this.currentSchool.supportPhone;
                this.mailTo = 'mailto:' + this.currentSchool.supportEmail;
            }
            this.loadHighlightedEvents();
            this.tryLoadBookingWindow();
            }, e => this.onError(e));
    }


    private loadCurrentStudent() {
        this.studentService.getCurrent().subscribe(
            (student: Student) => {
                this.student = student;
                this.loadComments();
                this.tryLoadBookingWindow();
                this.loadActiveCards(student.id);
                this.loadFreeTrialCatalog(student.id);
                this.loadNews();

            },
            (res: HttpErrorResponse) => this.onError(res));
    }

    loadActiveCards(studentId: number) {
        const today = moment().format('YYYY-MM-DD');
        const query = `validSince:[* TO ${today}] AND validUntil:[${today} TO *] AND student.id:${studentId}`;
        this.cardService.search({ query: query })
        .subscribe((response: HttpResponse<Card[]>) => {
            this.activeCards = response.body || [];
            this.studentCurrentCardInfoLoaded = true;
        },
        (error) => {
            this.onError(error);
        });
    }

    loadFreeTrialCatalog(studentId: number) {
        this.onlineCatalogSerice.queryOnlineCatalogOfFreeTrialCardTypes(studentId)
        .subscribe ((response: HttpResponse<CardType[]>) => {
            this.freeTrialAvailalbeCardTypes = response.body;

            if (this.freeTrialAvailalbeCardTypes && this.freeTrialAvailalbeCardTypes.length > 0) {
                this.showRedeemFreeTrialButton = true;
            }

        }, (error) => {
            this.onError(error);
        });
    }

    loadThisMonthFreeTrials() {
        this.principal
        .hasAnyAuthority(['ROLE_SCHOOL_ADMIN' ])
        .then(response => {
            if (!response) {
                return;
            }

            this.freeTrialsCardLoading = true;
            const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
            const endOfToday = moment().endOf('day').format('YYYY-MM-DD');
            const query = `cardType.acceptOnlinePayments:true AND validSince:[${startOfMonth} TO ${endOfToday}] AND cardType.price:0`;

            this.cardService.search({ query: query })
            .subscribe((response: HttpResponse<Card[]>) => {
                this.freeTrials = response.body || [];
                this.freeTrialsCardLoading = false;
            },
            (error) => {
                this.onError(error);
            });

            // see if the school proposes free trial cards
            this.cardTypeService.count({ query: 'price = 0 AND acceptOnlinePayments:true' })
            .subscribe((response: number) => {
                this.schoolProposeFreeTrials = response > 0;
            },
            (error) => {
                this.onError(error);
            });
        });

    }

    loadThisMonthNewStudents() {
        this.principal
        .hasAnyAuthority(['ROLE_SCHOOL_ADMIN' ])
        .then(response => {
            if (!response) {
                return;
            }

            this.newStudentsCardLoading = true;
            const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
            const endOfToday = moment().endOf('day').format('YYYY-MM-DD');
            const query = `user.activated:true AND createdDate:[${startOfMonth} TO ${endOfToday}]`;

            this.studentService.search({ query: query })
            .subscribe((response: HttpResponse<Student[]>) => {
                this.newStudents = response.body || [];
                this.newStudentsCardLoading = false;
            },
            (error) => {
                this.onError(error);
            });
        });

    }

    redeemFreeTrial() {
        if (!this.freeTrialAvailalbeCardTypes || this.freeTrialAvailalbeCardTypes.length === 0 ) {
            // this shpuld not happen try again to get available free trials
            this.loadFreeTrialCatalog(this.student.id);

            // let the user try again
            return;
        }

        // select the most recent free trial card type ( afterwards we could allow the user to select one)
        const freeTrialCardType = this.freeTrialAvailalbeCardTypes[0];
        if (!freeTrialCardType) {
            return;
        }

        let input: FreeTrialCardInput = new FreeTrialCardInput();
        input.studentId = this.student.id;
        input.cardTypeId = freeTrialCardType.id;
        this.isProcessingFreeTrialRequest = true;

        this.onlineCatalogSerice
            .createFreeTrialCard (input)
            .subscribe ((response: Card) => {
                // ✅ show animation(confetti, checkmark, etc.)
                this.showRedeemFreeTrialButton = false;
                this.showFreeTrielRedeemSucccessButton = true;
                this.isProcessingFreeTrialRequest = false;

                // ✅ wait 2 seconds, then redirect
                setTimeout(() => {
                    this.router.navigate(['/lesson'], {
                    queryParams: { freeTrial: 'true' } // pass info for celebratory message
                    });
                }, 2000);
            }, (error) => {
                this.onError(error);
            });
    }

    tryLoadBookingWindow(): void {
        if (this.currentSchool && this.student) {
            this.bookingWindow = this.studentUtilService.getBookingWindow(this.currentSchool, this.student);
            return;
        }
        this.bookingWindow = 0;
    }

    loadHighlightedEvents() {
        const query = 'highlighted:true AND NOT status:DRAFT AND school.id:' + this.currentSchool.id;

        this.eventService.search({
            query,
            size: this.maxHighlightedItems,
            sort: 'begining,asc'
        }).subscribe(
            (res: HttpResponse<Event[]>) => {
                this.onHighlightedEventsSuccess(res.body, res.headers);
            },
            (res: HttpErrorResponse) => {
                this.onError(res);
            }
        );
    }

    private onHighlightedEventsSuccess(data, headers) {
        this.highlightedevents = data;
    }

    private comesFromSuccessOnboardingSession() {
        let onboardingSuccess = this.route.snapshot.queryParams['onboarding']
        ?  this.route.snapshot.queryParams['onboarding']
        : null;
        return onboardingSuccess === 'success';
    }

    private comesFromIncompleteOnboardingSession() {
        let onboardingSuccess = this.route.snapshot.queryParams['onboarding']
        ?  this.route.snapshot.queryParams['onboarding']
        : null;
        return onboardingSuccess === 'incomplete';
    }

    public showCurrentCalendarWarning() {
        return this.currentSchoolCalendar === null;
    }

    public hasActiveCards(): boolean {
        return this.activeCards != null && this.activeCards.length >= 1 ;
    }

    public getAvailableAssistances(card: Card): number {
        return this.cardService.getAvailableAssistances(card);
    }

    public getStatusBadgeStyle(percentage: number): string {
        return this.studentUtilService.getStatusBadgeStyle(percentage);
    }

    registerAuthenticationSuccess() {
        this.eventManager.subscribe('authenticationSuccess', (message) => {
            this.principal.identity().then((account) => {
                this.activeCards = [];
                this.freeTrials = [];
                this.studentCurrentCardInfoLoaded = false;
                this.schoolOnlinePaymentsCardInfoLoaded = false;
                this.hasAdminRights = false;
                this.hasTeacherRole = false;
                this.highlightedevents = [];
                this.account = account;
                this.schoolProposeFreeTrials = false;
                this.loadAll();
            });
        });
    }

    isAuthenticated() {
        return this.principal.isAuthenticated();
    }

    login() {
        this.modalRef = this.loginModalService.open();
    }

    private onError(error: HttpErrorResponse) {
        this.alertService.error(error.error, null, null);
    }

    loadNews() {
        this.newsArticleService.findValidByDate({showInHomePage: true}).subscribe(
            (res: HttpResponse<NewsArticle[]>) => this.onNewsSuccess(res.body, res.headers),
            (res: HttpErrorResponse) => this.onError(res)
        );
    }

    loadComments() {
        this.studentCommentService.search({
            query: 'student.id:' + this.student.id + ' AND status:OPEN',
            sort: ['createdDate,desc'],
            size : 10
        }).subscribe(
            (res: HttpResponse<StudentComment[]>) => this.comments = res.body,
            (res: HttpErrorResponse) => this.onError(res)
            );
    }

    onNewsSuccess(response: any, headers): void {
        this.news = response;
    }

    ngOnDestroy() {
        this.comments = [] ;
        this.activeCards = [];
        this.freeTrials = [];
        this.highlightedevents = [];
    }

    openHelpLink() {
        if (this.currentSchool.helpUrl) {
            window.open(this.currentSchool.helpUrl);
        }
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/home/home.component.ts